export default {
    apiKey: "AIzaSyA153gXrh7rFIFm1o6HHiSZ3_O3z2ky4HM",
    authDomain: "vue3-firebase-9432b.firebaseapp.com",
    projectId: "vue3-firebase-9432b",
    storageBucket: "vue3-firebase-9432b.appspot.com",
    messagingSenderId: "540279711222",
    appId: "1:540279711222:web:7624a5614fd9ff01acd3d7",
    measurementId: "G-ZK7G5W9C19"
  };